import { MediaStreamAudioSupplier, MediaStreamAudioConsumer } from 'mind-sdk-web/lib/MediaStream';
import { MediaStreamAudioBuffer } from 'mind-sdk-web/lib/MediaStreamAudioBuffer';

export class MutableAudioSupplier implements MediaStreamAudioSupplier, MediaStreamAudioConsumer {
  private consumers = new Set<MediaStreamAudioConsumer>();
  private rawConsumer: MediaStreamAudioConsumer | null = null;
  private audioTrack: MediaStreamTrack | null = null;
  private muted = false;

  setMuted(muted: boolean): void {
    if (this.muted !== muted) {
      this.muted = muted;
      this.fireAudioBuffer();
    }
  }

  setRawConsumer(consumer: MediaStreamAudioConsumer | null): void {
    this.rawConsumer = consumer;

    if (consumer) {
      consumer.onAudioBuffer(this.audioTrack ? new MediaStreamAudioBuffer(this.audioTrack, false) : null, this);
    }
  }

  onAudioBuffer(audioBuffer: MediaStreamAudioBuffer | null): void {
    this.audioTrack = audioBuffer?.getTrack() ?? null;

    // update regular consumers
    this.fireAudioBuffer();

    // always forward to raw consumer
    this.rawConsumer?.onAudioBuffer(this.audioTrack ? new MediaStreamAudioBuffer(this.audioTrack, false) : null, this);
  }

  addAudioConsumer(consumer: MediaStreamAudioConsumer): void {
    this.consumers.add(consumer);

    if (this.audioTrack && !this.muted) {
      consumer.onAudioBuffer(new MediaStreamAudioBuffer(this.audioTrack, false), this);
    } else {
      consumer.onAudioBuffer(null, this);
    }
  }

  removeAudioConsumer(consumer: MediaStreamAudioConsumer): void {
    if (this.consumers.delete(consumer)) {
      consumer.onAudioBuffer(null, this);
    }
  }

  private fireAudioBuffer(): void {
    for (const consumer of this.consumers) {
      if (this.audioTrack && !this.muted) {
        consumer.onAudioBuffer(new MediaStreamAudioBuffer(this.audioTrack, false), this);
      } else {
        consumer.onAudioBuffer(null, this);
      }
    }
  }
}
